<form #parentForm="ngForm" novalidate>
  <div>
    <div>
      @if (isCreateExclusion) {
        <h2 class="margin-left-125">Add an exclusion</h2>
      }
      <p-accordion
        [multiple]="false"
        expandIcon="pi pi-fw pi-chevron-down"
        collapseIcon="pi pi-fw pi-chevron-up"
        class="full-width"
        [(value)]="selectedAccordionPanel"
      >
        <div class="margin-bottom">
          <p-accordion-panel value="ExclusionDetails">
            <p-accordion-header>
              <span
                ><h2>{{ ExclusionDetails }}</h2></span
              >
            </p-accordion-header>
            <p-accordion-content>
              <div>
                <app-exclusion-overview
                  #overviewComponent
                  (isChildFormValid)="isChildFormValid($event)"
                  [exclusionId]="exclusionId"
                  [pupilData]="pupilData"
                  [schoolId]="schoolId"
                  [isCreateExclusion]="isCreateExclusion"
                  [isOffRollEditingEnabled]="isOffRollEditingEnabled"
                ></app-exclusion-overview>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        </div>
        <div class="margin-bottom">
          <p-accordion-panel value="ExclusionReasons">
            <p-accordion-header>
              <span
                ><h2>{{ Reasons }}</h2></span
              >
            </p-accordion-header>
            <p-accordion-content>
              <div>
                <app-exclusion-reasons
                  #reasonsComponent
                  (isChildFormValid)="isChildFormValid($event)"
                  [exclusionId]="[exclusionId]"
                  [pupilName]="pupilData.studentName"
                  [isCreateExclusion]="isCreateExclusion"
                  [isStudentOffRoll]="pupilData.isOffRoll"
                  [isOffRollEditingEnabled]="isOffRollEditingEnabled"
                ></app-exclusion-reasons>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        </div>
        @if (!isCreateExclusion) {
          <div class="margin-bottom">
            <p-accordion-panel value="ExclusionSupportOfficers">
              <p-accordion-header>
                <span
                  ><h2>{{ SupportOfficers }}</h2></span
                >
              </p-accordion-header>
              <p-accordion-content>
                <div>
                  <app-exclusion-support-officers
                    [exclusionId]="exclusionId"
                    [pupilName]="pupilData.studentName"
                  ></app-exclusion-support-officers>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </div>
        }
        @if (!isCreateExclusion) {
          <div class="margin-bottom">
            <p-accordion-panel value="ExclusionMeetings">
              <p-accordion-header>
                <span
                  ><h2>{{ Meetings }}</h2></span
                >
              </p-accordion-header>
              <p-accordion-content>
                <div>
                  <app-exclusion-meetings
                    [exclusionId]="exclusionId"
                    [pupilData]="pupilData"
                    [isOffRollEditingEnabled]="isOffRollEditingEnabled"
                    [schoolId]="schoolId"
                  >
                  </app-exclusion-meetings>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </div>
        }
        <div class="margin-bottom">
          <p-accordion-panel value="ExclusionDocuments">
            <p-accordion-header>
              <span
                ><h2>{{ Documents }}</h2></span
              >
            </p-accordion-header>
            <p-accordion-content>
              <div>
                <app-student-exclusion-linked-document-list
                  #linkedDocumentListComponent
                  [exclusionId]="exclusionId"
                  [isCreateExclusion]="isCreateExclusion"
                  [pupilData]="pupilData"
                  [isOffRollEditingEnabled]="isOffRollEditingEnabled"
                  (backToExclusionsList)="navigateBackToExclusionList()"
                ></app-student-exclusion-linked-document-list>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        </div>
        @if (isCreateExclusion) {
          <div class="align-right">
            <button
              title="Cancel"
              label="Cancel"
              pButton
              class="button-custom margin-right"
              (click)="navigateBackToExclusionList()"
            ></button>
            <button
              (click)="createExclusion()"
              title="Create Exclusion"
              label="Create Exclusion"
              pButton
              class="button-custom margin-right"
              [disabled]="isCreateClicked"
            ></button>
          </div>
        }
      </p-accordion>
    </div>
  </div>
</form>
